import { render, staticRenderFns } from "./SuccessfulRequest.vue?vue&type=template&id=52c50a4e&scoped=true&"
import script from "./SuccessfulRequest.vue?vue&type=script&lang=js&"
export * from "./SuccessfulRequest.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulRequest.vue?vue&type=style&index=0&id=52c50a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c50a4e",
  null
  
)

export default component.exports